
export default {
  auth: false,
  layout: 'login',
  data: () => ({
    backendErrors: {},
    loader: false,
    data: {
      email: '',
      topic: '',
      content: ''
    }
  }),
  head () {
    return {
      titleTemplate: this.$t('contact.do') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.contact')
        }
      ],
    }
  },
  methods: {
    onSubmit () {
      this.loader = true
      this.$axios.post('/api/help-center/contact-not-auth', this.data).then(() => {
        setTimeout(()=>{
          this.loader = false
          window.location.replace('/kontakt')
        }, 1000)

        this.$buefy.toast.open({
          message: this.$t('contact.thanks'),
          type: 'is-success'
        })
      }).catch((e) => {
        this.$sentry.captureException(e)

        setTimeout(()=>{this.loader = false}, 1000)

        if (e.response && e.response.status === 422) {
          this.backendErrors = e.response.data.errors
        } else {
          this.$sentry.captureException(e)

          this.$buefy.toast.open({
            message: this.$t('something_wrong'),
            type: 'is-danger'
          })
        }
      })
    },
  }
}
